export default {
  // 商品列表
  // sort: orderIndex 1：价格升序 2：价格降序  saleIndex 1: 销量升序 2：销量降序
  async getGoodsListAsync(context, payload) {
    if (context.state.goodsList.status && payload.p === +context.state.goodsList.currentPage) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/sg/lists.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_GOODS_LIST', res.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  async getGoodsDetailAsync(context, payload) {
    try {
      const res = await this.$http.post('/sg/detail.html', payload);
      if (res.data.status === 1) {
        return Promise.resolve(res.data.data);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      }, { root: true });
      return Promise.reject(error);
    }
  },
  async addToCartAsync(context, payload) {
    try {
      const res = await this.$http.post('/c/add.html', payload);
      if (res.data.status === 1) {
        context.commit(
          'cart/RESET_CART_LIST',
          null,
          { root: true },
        );
        context.dispatch('cart/getCartListAsync', null, { root: true });
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      }, { root: true });
      return Promise.reject(error);
    }
  },
  async setGoodsFavoriteAsync(context, payload) {
    try {
      const res = await this.$http.post('/gc/setGoodsCollect.html', payload);
      if (res.data.status === 1) {
        context.commit(
          'center/RESET_FAVORITE_LIST',
          null,
          { root: true },
        );
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      }, { root: true });
      return Promise.reject(error);
    }
  },
  async setGoodsUnfavoriteAsync(context, payload) {
    try {
      const res = await this.$http.post('/gc/delGoodsCollect.html', payload);
      if (res.data.status === 1) {
        context.commit(
          'center/RESET_FAVORITE_LIST',
          null,
          { root: true },
        );
        await context.dispatch('center/getFavoriteListAsync', null, { root: true });
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit('TOGGLE_SNACKBAR', {
        type: 'error',
        text: error.message,
      }, { root: true });
      return Promise.reject(error);
    }
  },
};
